import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const CTASection = () => {
  return (
    <section className="bg-navy py-12">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-navy-foreground mb-3">
          Ready to Expand Your Trade Network?
        </h2>
        <p className="text-sm text-white max-w-xl mx-auto mb-8">
          Join hundreds of verified businesses and chambers already using the AAMECC
          digital platform to connect, trade, and grow across continents.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/register"
            className="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-gold text-gold-foreground font-semibold text-sm hover:opacity-90 transition-opacity"
          >
            Become a Member
            <ArrowRight className="w-4 h-4" />
          </Link>
          <Link
            to="/marketplace"
            className="inline-flex items-center justify-center gap-2 px-8 py-3.5 border border-navy-foreground/20 text-navy-foreground text-sm font-medium hover:border-gold hover:text-gold transition-colors"
          >
            Explore Directory
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
